import 'styles/pages/api.scss';
import '~scripts/main';

// Packages
import throttle from 'lodash/throttle';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';

// Components
import '~scripts/components/modals';
import HandleForm from '~scripts/components/forms/forms';

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// REQUEST
//
function submitSubscribeSandbox(form) {
  const formData = new FormData(form);
  const body = Object.fromEntries(formData.entries());

  return fetch('/subscribe/api_sandbox', {
    method: 'post',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(`${response.status}: ${response.statusText}`);
      }

      return response;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function initSubscribeSandbox(form) {
  if (!form) {
    return;
  }

  const handleForm = new HandleForm(form);

  const handleSubmit = throttle(() => {
    if (handleForm.getSending()) {
      return;
    }

    if (!handleForm.checkValidity()) {
      return;
    }

    handleForm.setSending(true);
    handleForm.disableSubmit();

    function success() {
      handleForm.handleSuccess();
    }

    function error(error) {
      handleForm.handleError(error);
    }

    submitSubscribeSandbox(form)
      .then(success, error)
      .finally(() => {
        handleForm.setSending(false);
        handleForm.enableSubmit();
      });
  }, 100);

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    handleSubmit();
  });
}

const subscribeSandboxForms = document.querySelectorAll('.js-sandbox-form');

subscribeSandboxForms.forEach((subscribeSandboxForm) => {
  initSubscribeSandbox(subscribeSandboxForm);
});
